'use client';

import { useTheme } from 'next-themes';
import { useEffect, useState } from 'react';

import { Comparison, Moon, Sun } from '@zoomit/icons';
import { cn, Collapsable } from '@zoomit/primitives';
import { Button, cssVar, theme, Typography } from '@zoomit/zoomit-ds';

import { onThemeChange } from '../../helpers/events';

const ToggleThemeButton = () => {
  const { theme: selectedTheme, setTheme } = useTheme();

  return (
    <Collapsable
      headSpacing={{ p: 0 }}
      bodySpacing={{ px: 0 }}
      title={
        <Typography fontSize={1.4} variant="subhead" textColor={cssVar(theme.text)} lineHeight={2}>
          قالب نمایش
        </Typography>
      }
    >
      <div className="my-2 grid grid-cols-3 gap-2">
        <Button
          variant={selectedTheme === 'light' ? 'contained' : 'outline'}
          onClick={() => {
            setTheme('light');
            onThemeChange('light');
          }}
          size="full width"
          rightIcon={<Sun className={cn(selectedTheme === 'light' ? 'fill-primary1' : 'fill-grey1')} />}
        >
          <Typography textColor={selectedTheme === 'light' ? cssVar(theme.white) : cssVar(theme.text)}>
            روز
          </Typography>
        </Button>
        <Button
          variant={selectedTheme === 'system' ? 'contained' : 'outline'}
          onClick={() => {
            setTheme('system');
            onThemeChange('auto');
          }}
          size="full width"
          rightIcon={
            <Comparison className={cn(selectedTheme === 'system' ? 'fill-primary1' : 'fill-grey1')} />
          }
        >
          <Typography textColor={selectedTheme === 'system' ? cssVar(theme.white) : cssVar(theme.text)}>
            خودکار
          </Typography>
        </Button>
        <Button
          variant={selectedTheme === 'dark' ? 'contained' : 'outline'}
          onClick={() => {
            setTheme('dark');
            onThemeChange('dark');
          }}
          size="full width"
          rightIcon={<Moon className={cn(selectedTheme === 'dark' ? 'fill-primary1' : 'fill-grey1')} />}
        >
          <Typography textColor={selectedTheme === 'dark' ? cssVar(theme.white) : cssVar(theme.text)}>
            شب
          </Typography>
        </Button>
      </div>
    </Collapsable>
  );
};

const ToggleThemeMobile = () => {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => setIsMounted(true), []);

  return isMounted ? <ToggleThemeButton /> : null;
};

export default ToggleThemeMobile;
